const donorAddress = {
    name: "",
    isSameAddress: false,
    firstName: "",
    lastName: "",
    Address: {
        line1: "",
        line2: "",
        line3: "",
        city: "",
        state: "",
        country: "",
        zipCode: "",
        isTouched: false
    },
    addressType: "Select one",
    relationToDonor: "Owner:Organization",
    taxIdNumber: ""
};

export const defaultMutualFundAHAV = [{
    type: "Select Account Type",
    VGAccountNumber: "",
    fundInformation: [
        {
            tickerSymbol: "",
            fundName: "",
            fundNumber: "",
            numberofShares: "",
            isAutoFilled: false,
            allShare:false,
            totalShares:-1,
            cusip:null 
        }
    ],
    Donors: [{
        name: "",
        isSameAddress: false,
        Address: {
            line1: "",
            line2: "",
            line3: "",
            city: "",
            state: "",
            country: "",
            zipCode: "",
            isTouched: false
        },
        addressType: "Select one",
        relationToDonor: "",
        taxIdNumber: ""
    },
    donorAddress
]
}];

export const defaultSecurityGiftAHAV = [{
    type: "Select Account Type",
    holdingFirm: "",
    VGAccountNumber: "",
    fundInformation: [
        {
            tickerSymbol: "",
            securityName: "",
            numberofShares: "",
            isAutoFilled: false,
            cusip:null,
            allShare:false,
            totalShares:-1
        }
    ],
    Donors: [{
        name: "",
        isSameAddress: false,
        Address: {
            line1: "",
            line2: "",
            line3: "",
            city: "",
            state: "",
            country: "",
            zipCode: "",
            isTouched: false
        },
        addressType: "Select one",
        relationToDonor: "",
        taxIdNumber: ""
    },
    donorAddress
]
}];


export const defaultMutualFundAHOV = [{
    type: "Select Account Type",
    holdingFirm: "",
    VGAccountNumber: "",
    fundInformation: [
        {
            tickerSymbol: "",
            fundName: "",
            fundNumber: "",
            numberofShares: "",
            isAutoFilled: false,
            allShare:false,
            totalShares:-1,
            cusip:null 
        }
    ],
    Donors: [{
        name: "",
        isSameAddress: false,
        Address: {
            line1: "",
            line2: "",
            line3: "",
            city: "",
            state: "",
            country: "",
            zipCode: "",
            isTouched: false
        },
        addressType: "Select one",
        relationToDonor: "",
        taxIdNumber: ""
    },
    donorAddress
]
}];


export const defaultSecurityGiftAHOV = [{
    type: "Select Account Type",
    holdingFirm: "",
    VGAccountNumber: "",
    fundInformation: [
        {
            tickerSymbol: "",
            securityName: "",
            numberofShares: "",
            isAutoFilled: false,
            cusip:null,
            allShare:false,
            totalShares:-1
        }
    ],
    Donors: [{
        name: "",
        isSameAddress: false,
        firstName: "",
        lastName: "",
        Address: {
            line1: "",
            line2: "",
            line3: "",
            city: "",
            state: "",
            country: "",
            zipCode: "",
            isTouched: false
        },
        addressType: "Select one",
        relationToDonor: "",
        taxIdNumber: ""
    },
    donorAddress
]
}];

export const defaultCheck = [{
    type: "Select Account Type",
    amount: "",
    Donors: [{
        name: "",
        firstName: "",
        lastName: "",
        isSameAddress: false,
        Address: {
            line1: "",
            line2: "",
            line3: "",
            city: "",
            state: "",
            country: "",
            zipCode: "",
            isTouched: false
        },
        addressType: "Select one",
        relationToDonor: "",
        taxIdNumber: ""
    },
    donorAddress
]
}];

export const defaultWire = [{
    type: "Select Account Type",
    amount: "",
    Donors: [{
        name: "",
        isSameAddress: false,
        Address: {
            line1: "",
            line2: "",
            line3: "",
            city: "",
            state: "",
            country: "",
            zipCode: "",
            isTouched: false
        },
        addressType: "Select one",
        relationToDonor: "",
        taxIdNumber: ""
    },
    donorAddress
]
}];

export const defaultStock = [{
    type: "Select Account Type",
    fundInformation: [
        {
            tickerSymbol: "",
            securityName: "",
            numberofShares: "",
            isAutoFilled: false,
            cusip:null,
            allShare:false,
            totalShares:-1
        }
    ],
    Donors: [{
        name: "",
        isSameAddress: false,
        Address: {
            line1: "",
            line2: "",
            line3: "",
            city: "",
            state: "",
            country: "",
            zipCode: "",
            isTouched: false
        },
        addressType: "Select one",
        relationToDonor: "Owner:Organization",
        taxIdNumber: ""
    },
    donorAddress
]
}];


export const defaultAllocation = {
    availableBalanceDate: 44343434,
    pricePerUnitDate: 323232323,
    portfolioSolution: [
      {
        isPriceIncreased: true,
        name: "Conservative Growth",
        availableBalance: "1115125.35",
        pricePerUnit: 23.2,
        percentage:5
      },
      {
        isPriceIncreased: false,
        name: "Moderate Growth",
        availableBalance: "142586.28",
        pricePerUnit: 45.8,
        percentage:25
      },
      {
        isPriceIncreased: false,
        name: "Gift Preservation",
        availableBalance: "$1115125.35",
        pricePerUnit: 105,
        percentage:25
      },
      {
        isPriceIncreased: false,
        name: "Growth",
        availableBalance: "142586.28",
        pricePerUnit: 23.2,
        percentage:25
      }
    ],
    portfolioBuilder: [
      {
        isPriceIncreased: true,
        name: "Money Market",
        availableBalance: "563486.28",
        pricePerUnit: 23.2,
        percentage:3
      },
      {
        isPriceIncreased: false,
        name: "Short-Term Bond",
        availableBalance: "142586.28",
        pricePerUnit: 45.8,
        percentage:12
      },
      {
        isPriceIncreased: true,
        name: "Total Bond",
        availableBalance: "1115125.35",
        pricePerUnit: 105,
        percentage:5
      },
      {
        isPriceIncreased: false,
        name: "Total Internationl Bond",
        availableBalance: "$142,586.28",
        pricePerUnit: 23.2,
        percentage:10
      },
      {
        isPriceIncreased: true,
        name: "Total Equity",
        availableBalance: "142586.28",
        pricePerUnit: 23.2,
        percentage:3
      },
      {
        isPriceIncreased: false,
        name: "Total U.S. Stock",
        availableBalance: "43123",
        pricePerUnit: 45.8,
        percentage:12
      },
      {
        isPriceIncreased: true,
        name: "Total International Stock",
        availableBalance: "142586.28",
        pricePerUnit: 105,
        percentage:5
      },
      {
        isPriceIncreased: false,
        name: "Balanced Index",
        availableBalance: "826386.28",
        pricePerUnit: 43.2,
        percentage:10
      },
      {
        isPriceIncreased: true,
        name: "Wellington",
        availableBalance: "142586.28",
        pricePerUnit: 23.2,
        percentage:3
      },
      {
        isPriceIncreased: false,
        name: "European Stock",
        availableBalance: "1632586.28",
        pricePerUnit: 45.4,
        percentage:12
      },
      {
        isPriceIncreased: true,
        name: "Pacific Stock",
        availableBalance: "3586.28",
        pricePerUnit: 73.1,
        percentage:5
      },
      {
        isPriceIncreased: false,
        name: "Emerging Markets",
        availableBalance: "8586.28",
        pricePerUnit: 98.3,
        percentage:10
      }
    ],
    valueDrivenInvestment: [
      {
        isPriceIncreased: true,
        name: "ESG U.S. Stock",
        availableBalance: "83586.28",   
        pricePerUnit: 23.2, 
        percentage:27
      },
      {
        isPriceIncreased: false,
        name: "ESG International Stock",
        availableBalance: "9586.28",
        pricePerUnit: 45.8,
        percentage:13
      },
      {
        isPriceIncreased: false,
        name: "ESG Global Stock",
        availableBalance: 43434,
        pricePerUnit: 105,
        percentage:13
      }
    ]
  }

